import { render, staticRenderFns } from "./ViewNav.vue?vue&type=template&id=219783c2"
import script from "./ViewNav.vue?vue&type=script&lang=js"
export * from "./ViewNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('219783c2')) {
      api.createRecord('219783c2', component.options)
    } else {
      api.reload('219783c2', component.options)
    }
    module.hot.accept("./ViewNav.vue?vue&type=template&id=219783c2", function () {
      api.rerender('219783c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/ViewNav.vue"
export default component.exports